import { request } from "./request";

export default {
  async fetch(page = null) {
    return await request("/api/hint", { page });
  },

  async markAsSeen(id) {
    return await request({
      method: "PUT",
      url: `/api/hint/${encodeURIComponent(id)}/mark_as_seen`,
    });
  },

  async changeTalentStateState(id, state) {
    return await request({
      method: "PUT",
      url: `/api/hint/talent_state/${encodeURIComponent(id)}`,
      data: { state },
    });
  },
};
